export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./User.vue?vue&type=template&id=ada6e5a6&"


//////////////////
// WEBPACK FOOTER
// ./src/components/side-bar/User.vue?vue&type=template&id=ada6e5a6&
// module id = 899
// module chunks = 0